import { render, staticRenderFns } from "./DynamicColumnParameter.vue?vue&type=template&id=2e6dc9ff&"
import script from "./DynamicColumnParameter.vue?vue&type=script&lang=ts&"
export * from "./DynamicColumnParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports